import { ProductPackage, RegistrationFormControl } from '@app/_store';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RegistrationActions {
  export class Initialize {
    static readonly type = '[Registration] Initialize';
  }

  export class Enable {
    static readonly type = '[REGISTRATION] Enable';
  }

  export class Reset {
    static readonly type = '[REGISTRATION] Reset';
  }

  export class AddFormControl {
    static readonly type = '[REGISTRATION] Add FormControl';
    constructor(public formControl: RegistrationFormControl) {}
  }

  export class AddProductPackage {
    static readonly type = '[REGISTRATION] Add Product Package';
    constructor(public pkg: ProductPackage) {}
  }

  export class UpdateProductPackage {
    static readonly type = '[REGISTRATION] Update Product Package';
    constructor(public pkg: ProductPackage) {}
  }

  export class DeleteProductPackage {
    static readonly type = '[REGISTRATION] Delete Product Package';
    constructor(public id: string) {}
  }

  export class RemoveFormControl {
    static readonly type = '[REGISTRATION] Remove FormControl';
    constructor(public id: string) {}
  }

  export class ReorderFormControls {
    static readonly type = '[REGISTRATION] Reorder FormControl';
    constructor(
      public previousIndex: number,
      public currentIndex: number
    ) {}
  }

  export class Save {
    static readonly type = '[REGISTRATION] Save';
  }

  export class UpdateConfirmationText {
    static readonly type = '[REGISTRATION] Update Confirmation Text';
    constructor(public confirmationText: string) {}
  }
}
